import { useEffect, useState } from 'react';

/**
 * Selected / expanded folder ids and the open context menu.
 */
export function useAtlasSelection() {
  const [expandedId, setExpandedId] = useState(null);
  const [ctx, setCtx] = useState(null);
  const [selectedIds, setSelectedIds] = useState(() => new Set());

  useEffect(() => {
    if (!ctx) return undefined;
    const close = () => setCtx(null);
    window.addEventListener('click', close);
    return () => window.removeEventListener('click', close);
  }, [ctx]);

  return {
    expandedId,
    setExpandedId,
    ctx,
    setCtx,
    selectedIds,
    setSelectedIds,
  };
}

/** Drop selected/expanded ids that are no longer in the tree. */
export function useAtlasSelectionSync(nodes, expandedId, setExpandedId, setSelectedIds) {
  useEffect(() => {
    const ids = new Set(nodes.map((n) => n.id));
    if (expandedId && !ids.has(expandedId)) setExpandedId(null);
    setSelectedIds((prev) => {
      let changed = false;
      const next = new Set();
      for (const id of prev) {
        if (ids.has(id)) next.add(id);
        else changed = true;
      }
      return changed ? next : prev;
    });
  }, [nodes, expandedId, setExpandedId, setSelectedIds]);
}
